import { useQuery } from '@tanstack/react-query';
import { getPushNotificationToken } from 'shared/services/backend-api/helpers';
import { ID } from 'shared/types/id';

export const queryKey = 'push-notification-token';

export const useCachedPushNotificationTokenQuery = (uid?: ID) =>
  useQuery({
    queryKey: [queryKey, uid],
    queryFn: async () => getPushNotificationToken(uid!) ?? null,
    enabled: !!uid,
  });
